/** @format */

import { END_POINT, headersFormData } from "utils";
import { deleteRequest, getRequest, postRequest } from "./axios";
import { IdForm, FormSprintUpdate, FormSprintStore } from "types";
import { toFormData } from "axios";

export const sprintService = {
  onGetList: async (projectId, page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/sprints?page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  show: async (projectId, id) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/sprints/${id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: FormSprintStore) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/sprints`, toFormData(payload), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: FormSprintUpdate) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/sprints/${payload.id}`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (payload: IdForm) => {
    try {
      const rs = await deleteRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/sprints/${payload.id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};

